import { effect, Injectable, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { LocalizationService } from 'src/core/utilitites/localization.service';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
    constructor(private localizationService: LocalizationService) {
        super();
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.getAndInitTranslations();
        });

        this.getAndInitTranslations();
    }

    public stringLabels = ['label.gb.items_per_page', 'label.gb.next_page', 'label.gb.previous_page', 'label.gb.first_page', 'label.gb.last_page'];
    public labels: Record<string, string>;
    getAndInitTranslations() {
        this.translateStrings();
        this.nextPageLabel = '';
        this.previousPageLabel = '';
        this.firstPageLabel = '';
        this.lastPageLabel = '';
        this.getRangeLabel = (
            page: number,
            pageSize: number,
            length: number
        ) => {
            const initialText = this.translate('label.gb.showing');
            if (length == 0 || pageSize == 0) {
                return `${initialText} 0 ${this.translate(
                    'label.gb.of'
                )} ${length}`;
            }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            const endIndex =
                startIndex < length
                    ? Math.min(startIndex + pageSize, length)
                    : startIndex + pageSize;
            return `${initialText} ${startIndex + 1
                } - ${endIndex} ${this.translate('label.gb.of')} ${length}`;
        };
        // this.changes.next();
        setInterval(() => {
            let dom = document.getElementsByClassName(
                'mat-mdc-paginator-page-size-label'
            );
            if (dom) {
                Array.from(dom).forEach(ele => {
                    let d = dom[0];
                    ele.innerHTML = this.labels['label.gb.items_per_page'];
                })
            }
        }, 500);
    }

    translate(key: string) {
        return this.localizationService.generateLocalizedStr(key);
    }
    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

}
